/* eslint-disable react/jsx-pascal-case */
import { useState } from "react";
import styled from "styled-components";
import { Content_Text } from "../Component/theme";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CloseButtonIcon } from "../image/white_x.svg";
import { ReactComponent as ArrowButtonIcon } from "../image/white_arrow.svg";
import { ReactComponent as Fms_Icon } from "../image/fms_icon.svg";
import { ReactComponent as Ssms_Icon } from "../image/ssms_icon.svg";

const Fixed_Div = styled.div`
  position: fixed;
  display: flex;
  padding: 15px;
  align-items: center;
  justify-content: center;
  top: 45%;
  right: 50px;
  flex-direction: column;
  z-index: 11;
  @media (max-width: 800px) {
    display: none;
  }
  gap: 30px;
`;

const SideBtn = styled.button`
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #383838;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
`;

const SideBtn2 = styled.button`
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #06091f 0%, #294888 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  color: white;
  font-weight: bold;
`;

const FmsCard = styled.div`
  position: fixed;
  right: 50px;
  top: 26%;
  width: 170px;
  padding: 20px 16px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  z-index: 12;

  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const FmsHeader = styled.div`
  font-weight: 700;
  font-size: 18px;
`;

const FmsItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

const ServiceBtn = styled.button`
  margin-top: 10px;
  padding: 10px 0;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg, #294888 0%, #06091f 100%);
  color: white;
  font-weight: 600;
  cursor: pointer;
`;

const Info_Text = styled(Content_Text)`
  padding: 5px 7px;
  border-radius: 5px;
  color: #294888;
  background-color: #e6eeff;
  margin-right: 5px;
`;
const Blue_Text = styled(Content_Text)`
  color: #294888;
  font-size: 18px;
`;

function Side_FMS_New(width) {
  const navigation = useNavigate();
  const [open, setOpen] = useState(true);

  const go_Top = (item) => {
    window.scrollTo({ top: 0 });
  };
  return (
    <>
      <Fixed_Div>
        {open && (
          <FmsCard>
            <FmsHeader>
              이런{" "}
              <Blue_Text $small $xbold>
                서비스
              </Blue_Text>
              도 있어요!
            </FmsHeader>

            <FmsItem>
              <Ssms_Icon width={18} height={18} />
              <Content_Text $small $bold>
                안전관리플랫폼
              </Content_Text>
            </FmsItem>

            <div>
              <Info_Text $xsmall>위험성평가</Info_Text>
              <Info_Text $xsmall>TBM</Info_Text>
            </div>
            <div>
              <Info_Text $xsmall>MSDS</Info_Text>
              <Info_Text $xsmall>사고조사</Info_Text>
            </div>

            <ServiceBtn onClick={() => navigation("/SSMS")}>
              서비스 보기
            </ServiceBtn>
          </FmsCard>
        )}
        {open ? (
          <SideBtn onClick={() => setOpen((prev) => !prev)}>
            <CloseButtonIcon />
          </SideBtn>
        ) : (
          <SideBtn2 onClick={() => setOpen((prev) => !prev)}>
            <Ssms_Icon width={18} height={18} />
            <div>NEW</div>
          </SideBtn2>
        )}
        <SideBtn onClick={go_Top}>
          <ArrowButtonIcon />
        </SideBtn>
      </Fixed_Div>
    </>
  );
}

export default Side_FMS_New;
